module.exports = __webpack_public_path__ + "static/BTS_Writing-1623a722740ee73c9faedf2368fd5f64.jpg";